<template>
    <div class="content">
        <div class="flex-box1">
            <img class="logo" :src="logo" alt="">
            <div class="main-title">
                <div class="notice font-main van-ellipsis">{{ name }}</div>
                <div class="notice font-main card font-card">{{ notice }}</div>
                <div class="notice font-main1">${{ amount }}</div>
            </div>
        </div>

        <div class="main">
            <div class=" item">
                <div class="font-main2">{{ rate }}%</div>
                <div class="font-sub">{{ $t('lang.利率') }}</div>
            </div>
            <div class=" item">
                <div class="font-main2">{{ day }}{{ returnCy() }}</div>
                <div class="font-sub">{{ $t('lang.周期') }}{{ rate }}%</div>
            </div>
            <div class=" item">
                <div class="font-main2">{{ used }}/{{ total }}</div>
                <div class="font-sub">{{ $t('lang.已购') }}/{{ $t('lang.限购') }}</div>
				<!-- 显示页面/#/itemNew -->
            </div>
        </div>
        <div class="action">
            <div class="progress">
                <van-progress :percentage="used/total*100" stroke-width="8" color="#be9f82"/>

<!--                <div class="info">{{ percent }}%</div>-->
            </div>
            <div class="btn-action">
                <div class="btn" @click="$emit('click')">
                    {{ $t('lang.立即合作') }}
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        name: '',
        day: '',
        amount: '',
        rate: '',
        used: '',
        total: '',
        percent: '',
        logo:'',
        ms: '',
    },
    computed:{
        notice(){
           if( this.ms === 0){
                return this.$t('lang.notice')
           }else if(this.ms === 1){
               return this.$t('lang.notice1')
           }else if(this.ms === 2){
               return this.$t('lang.notice2')
           }
        }
    },
    methods:{
        returnCy(){
            let msg = ''
            let ms = this.ms;
            switch (ms) {
                case 0:
                    msg = this.$t('utils.day')
                    break;
                case 1:
                    msg = this.$t('lang.小时');
                    break;
                case 2:
                    msg = this.$t('lang.天后结算');
                    break;
                default:
                    break;
            }
            return msg;
        },
    }
}
</script>


<style scoped lang="less">
.action {
  display: flex;
  justify-content: space-between;
  background: #3E2E21;
  padding: 10px 6px 10px 16px;
  border-radius: 10px;

  .btn-action {
    width: 100px;
    box-sizing: border-box;
    padding: 10px;

    .btn {
      width: 80px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 10px;
      font-size: 10px;
      background: linear-gradient(0deg, rgba(182, 140, 115, 1) 0%, rgba(243, 226, 210, 1) 100%) !important;
    }
  }
}

.card {
  max-width: 130px !important;
  text-align: center !important;
  border-radius: 20px;
  background: linear-gradient(90deg, rgba(231, 197, 170, 1) 0%, rgba(246, 229, 213, 1) 49%, rgba(230, 199, 155, 1) 100%);
}

.main-title {
  overflow: hidden;
  flex: 1;
  padding-left: 20px;
}

.flex-box1 {
  display: flex;
  align-items: center;
}

.flex-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.font-card {
  color: #5a211b !important;
  font-size: 13px !important;
}

.font-main {
  color: #dccfc7;
  font-size: 16px;
}

.font-main1 {
  color: #dccfc7;
  font-size: 20px;
}

.font-main2 {
  color: #dccfc7;
  font-size: 18px;
  margin-bottom: 12px;
}

.font-sub {
  font-size: 12px;
  color: #8c7f77;
}

.font-size-sub {
  font-size: 16px;
}

.content {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #281B13;
  border-radius: 8px;
  overflow: hidden;
  padding: 16px;

  .notice {
    white-space: nowrap;
    box-sizing: border-box;
    padding: 10px 6px;
    max-width: 200px;

    //height: 26px;
    //line-height: 16px;
    text-align: left;
  }

  .logo {
    width: 144px;
    height: 114px;
    border-radius: 6px;
  }

  .progress {
    flex: 1;
    margin-top: 24px;
    margin-bottom: 16px;
    height: 12px;
    //background-color: #0a0c07;
    position: relative;

    .info {
      border-radius: 12px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      padding: 4px 6px;
      color: #FFFFFF;
      background-color: #be9f82;
    }
  }

  .main {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 10px;

    .item {
      width: 33%;
      text-align: center;
      margin: 10px 0;

      .border {
        white-space: nowrap;
        width: 50px;
        border: 1px solid #8c7f77;
        border-radius: 4px;
        padding: 4px 8px;
      }
    }
  }
}
</style>
